// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1327":"aca563e3ea03a646","2364":"88bdb71e4f719699","2469":"d08e5e2e14010171","2887":"8a5216e4f32af853"}[chunkId] + ".js";
};